import { Component, OnInit } from '@angular/core';
import { ScreenBreakpointObserverService } from '../../shared/foundation/utils/breakpoint-observer.service';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
})
export class LayoutComponent implements OnInit {
  isMobileLayout = false;

  constructor(private bpObserverService: ScreenBreakpointObserverService) {}

  ngOnInit(): void {
    this.bpObserverService.screenSizeObserver.subscribe({
      next: (res) => {
        if (res.length <= 2) {
          this.isMobileLayout = true;
        } else {
          this.isMobileLayout = false;
        }
      },
    });
  }
}
